import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_DESPESASGERAIS_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterTodos(filtro) {
        return axiosJwt
            .get(
                `${api}/despesasgerais/finalizacao/pagamentos?situacao=${filtro.situacao}&status=${filtro.status}&dataInicial=${filtro.dataInicial}&dataFinal=${filtro.dataFinal}`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterPorId(pagamentoId) {
        return axiosJwt
            .get(`${api}/despesasgerais/finalizacao/pagamentos/${pagamentoId}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    downloadPagamentoAnexo(pagamentoAnexoId) {
        return axiosJwt
            .get(`${api}/despesasgerais/finalizacao/pagamentos/anexos/${pagamentoAnexoId}/baixar`, {
                responseType: 'blob'
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    downloadPagamentoDocumento(pagamentoDocumentoId) {
        return axiosJwt
            .get(`${api}/despesasgerais/finalizacao/pagamentos/documentos/${pagamentoDocumentoId}/baixar`, {
                responseType: 'blob'
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    aprovarReprovarPagamento(aprovaReprovaPagamentoDto) {
        return axiosJwt
            .post(
                `${api}/despesasgerais/finalizacao/pagamentos/aprovar`,
                aprovaReprovaPagamentoDto
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterAnexos(pagamentoId) {
        return axiosJwt
            .get(
                `${api}/despesasgerais/finalizacao/pagamentos/${pagamentoId}/anexos`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterDocumentos(pagamentoId) {
        return axiosJwt
            .get(
                `${api}/despesasgerais/finalizacao/pagamentos/${pagamentoId}/documentos`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterAnexo(pagamentoAnexoId) {
        return axiosJwt
            .get(`${api}/despesasgerais/finalizacao/pagamentos/anexos/${pagamentoAnexoId}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterAnexosTipos() {
        return axiosJwt
            .get(`${api}/despesasgerais/finalizacao/pagamentos/anexos/tipos`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterDocumentosTipos() {
        return axiosJwt
            .get(`${api}/despesasgerais/finalizacao/pagamentos/documentos/tipos`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirPagamentoAnexo(pagamentoAnexo) {
        const formData = new FormData()
        formData.append('pagamentoId', pagamentoAnexo.pagamentoId)
        formData.append('tipoAnexoId', pagamentoAnexo.tipoId)
        formData.append('descricao', pagamentoAnexo.descritivo)
        formData.append('arquivo', pagamentoAnexo.arquivo)
        formData.append('numeroNotaDocumento', pagamentoAnexo.numeroNotaDocumento)
        formData.append('codigoVerificacao', pagamentoAnexo.codigoVerificacao)
        if (pagamentoAnexo.dataEmissao != '') {
            formData.append('dataEmissao', pagamentoAnexo.dataEmissao)
        }

        return axiosJwt
            .post(
                `${api}/despesasgerais/finalizacao/pagamentos/${pagamentoAnexo.pagamentoId}/anexos`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    atualizarPagamentoAnexo(pagamentoAnexo) {
        const formData = new FormData()
        formData.append('pagamentoAnexoId', pagamentoAnexo.pagamentoAnexoId)
        formData.append('pagamentoId', pagamentoAnexo.pagamentoId)
        formData.append('tipoAnexoId', pagamentoAnexo.tipoId)
        formData.append('descricao', pagamentoAnexo.descritivo)
        formData.append('arquivo', pagamentoAnexo.arquivo)
        formData.append('numeroNotaDocumento', pagamentoAnexo.numeroNotaDocumento)
        formData.append('codigoVerificacao', pagamentoAnexo.codigoVerificacao)
        if (pagamentoAnexo.dataEmissao != '') {
            formData.append('dataEmissao', pagamentoAnexo.dataEmissao)
        }

        return axiosJwt
            .patch(
                `${api}/despesasgerais/finalizacao/pagamentos/${pagamentoAnexo.pagamentoId}/anexos`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluirAnexo(pagamentoAnexo) {
        return axiosJwt
            .put(
                `${api}/despesasgerais/finalizacao/pagamentos/${pagamentoAnexo.pagamentoId}/anexos`,
                pagamentoAnexo
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterHistorico(pagamentoId) {
        return axiosJwt
            .get(`${api}/despesasgerais/finalizacao/pagamentos/${pagamentoId}/historico`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluirDocumento(pagamentoDocumento) {
        return axiosJwt
            .put(
                `${api}/despesasgerais/finalizacao/pagamentos/${pagamentoDocumento.pagamentoId}/documentos`,
                pagamentoDocumento
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterTimeLine(pagamentoId) {
        return axiosJwt
            .get(`${api}/despesasgerais/finalizacao/pagamentos/${pagamentoId}/timeline`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterCertidoes(pagamentoId) {
        return axiosJwt
            .get(
                `${api}/despesasgerais/finalizacao/pagamentos/${pagamentoId}/certidoes`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    definirPrioritario(pagamentoId) {
        return axiosJwt
            .patch(
                `${api}/despesasgerais/finalizacao/pagamentos/${pagamentoId}/prioritario`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirPagamentoDocumento(pagamentoAnexo) {
        const formData = new FormData()
        formData.append('pagamentoId', pagamentoAnexo.pagamentoId)
        formData.append('tipoAnexoId', pagamentoAnexo.tipoId)
        formData.append('descricao', pagamentoAnexo.descritivo)
        formData.append('arquivo', pagamentoAnexo.arquivo)

        return axiosJwt
            .post(
                `${api}/despesasgerais/finalizacao/pagamentos/${pagamentoAnexo.pagamentoId}/documentos`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    definirEspecial(pagamentoId) {
        return axiosJwt
            .patch(
                `${api}/despesasgerais/finalizacao/pagamentos/${pagamentoId}/especial`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    exportar(id) {
        let url = `${api}/despesasgerais/finalizacao/pagamentos/${id}/exportar`
        return axiosJwt
            .get(url, {
                responseType: 'blob'
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    retornarPagamento(pagamentoId) {
        return axiosJwt
            .patch(`${api}/despesasgerais/finalizacao/pagamentos/${pagamentoId}/retornaruabs`)
            .then(response => {
                return response.data
            }).catch(error => {
                return errorHandler(error)
            })
    },

    obterCategoriasReprovacao() {
        return axiosJwt
            .get(`${api}/despesasgerais/finalizacao/pagamentos/reprovarpagamentoopcoes`)
            .then(response => {
                return response.data
            }).catch(error => {
                return errorHandler(error)
            })
    },

    obterCategoriasAprovacaoJustificada() {
        return axiosJwt
            .get(`${api}/despesasgerais/finalizacao/pagamentos/aprovacaojustificadaopcoes`)
            .then(response => {
                return response.data
            }).catch(error => {
                return errorHandler(error)
            })
    }
}